<script setup>
import { computed, ref } from 'vue'
import { useCalendarStore } from '@/views/apps/calendar/useCalendarStore'
import { useI18n } from 'vue-i18n'
import { sanitizeHtml } from "@/utils/strings"

const { t } = useI18n()
const calendarStore = useCalendarStore()

const dialog = computed(() => {
  return calendarStore.agreement && typeof calendarStore.agreement === 'object'
})

const isLoading = ref(false)

const handleConfirm = async () => {
  if (!calendarStore.agreement?.id) return

  isLoading.value = true
  try {
    const response = await $backend('/agreements/accept', {
      method: 'POST',
      body: {
        id: calendarStore.agreement.id,
      },
    })

    if (response.success) {
      calendarStore.agreement = false
    }
  } catch (error) {
    console.error('Error accepting agreement:', error)
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <VDialog
    class="agreement-dialog"
    v-model="dialog"
    persistent
    max-width="1024"
  >
    <VCard class="pa-2 d-flex flex-column" style="max-block-size: 80vh;">
      <VCardText
        v-if="calendarStore.agreement?.content"
        v-html="sanitizeHtml(calendarStore.agreement.content)"
        class="flex-grow-1 overflow-y-auto agreement-container"
      />
      <VCardActions class="justify-end mt-2 flex-shrink-0">
        <VBtn
          color="green"
          variant="flat"
          :loading="isLoading"
          @click="handleConfirm"
        >
          {{ t('confirm_agreement') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style>
  .agreement-dialog {
    h2 {
      margin-block-end: 1rem;
    }

    ol {
      margin-block-end: 1rem;
      margin-left: 2rem;
    }

    li {
      margin-block-end: 0.25rem;
    }
  }
</style>
